/**
 * Which pieces of the skeleton's shared chrome the current tenant renders.
 *
 * Declared by the tenant as `config.chrome` (see `TenantChrome` in
 * @crosure/tenant-runtime). Everything defaults to ON, so a tenant that says
 * nothing — commsure, ooredoo, every sandbox tenant — keeps exactly the
 * behaviour it had before this block existed.
 *
 * The `?? true` is deliberate even though `mergeWithDefaults` already fills
 * these in: local dev links @crosure/tenant-runtime as a compiled `dist/`, so
 * a runtime built before v0.2.5 hands back a bundle with no `chrome` key at
 * all. Falling back here fails open (full chrome) rather than blank.
 */
import tenant from '@/lib/tenant'

const declared = tenant.config?.chrome

export const tenantChrome = {
	/** Render the public landing navbar at all. */
	landingNavbar: declared?.landingNavbar ?? true,
	/** Show the Login / Dashboard button in the navbars. */
	login: declared?.login ?? true,
	/** Show the hamburger site menu in the landing navbar. */
	siteMenu: declared?.siteMenu ?? true,
	/** Where the navbar Login button goes. `/dashboard` (the customer portal)
	 *  unless the tenant sends its buyers to the Sales dashboard instead. */
	loginHref: declared?.loginHref || '/dashboard',
}

export default tenantChrome
